<template>
    <div class="cd-timeline-content cd-timeline-card--default">
        <div class="cd-timeline-content-text">
            <div class="container-authorization">
                <CompassAvatarName
                    :firstname="getTargetedStaffFirstname"
                    :lastname="getTargetedStaffLastname"
                    size="extra-small"
                    class="user-profile"
                >
                    <CompassAvatar
                        :initials="getTargetedStaffInitials"
                        size="extra-small"
                        :colorType="getTargetStaffAvatarRandomColor"
                    />
                </CompassAvatarName>
                <span class="typographies-paragraph-medium-regular">
                    {{ eventText }}
                </span>
            </div>
            <!-- Date -->
            <span class="date-log typographies-paragraph-small-regular">
                {{ $filters.dateFormatter(oneLog.timestamp, 'NORMAL_DATE_TIME', true) }}
            </span>
        </div>
    </div>
</template>

<script>
import IconMixin from 'mixins/IconMixin';
import { randAvatarColorFullname } from 'utils/avatar';

export default {
    mixins: [IconMixin],
    props: {
        oneLog: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            events: ['authorization.accepted', 'authorization.send'],
        };
    },
    computed: {
        getTargetedStaffFirstname() {
            return this.oneLog.more.targeted_staff.firstname;
        },
        getTargetedStaffLastname() {
            return this.oneLog.more.targeted_staff.lastname;
        },
        getTargetedStaffInitials() {
            return `${this.getTargetedStaffFirstname[0]}${this.getTargetedStaffLastname[0]}`;
        },
        getTargetStaffAvatarRandomColor() {
            const fullName = `${this.getTargetedStaffFirstname} ${this.getTargetedStaffLastname}`;
            return randAvatarColorFullname(fullName);
        },
        eventText() {
            return this.$l10n.__(this.extractEventText(this.oneLog.text, this.getEvent()));
        },
    },
    methods: {
        getEvent() {
            for (const event of this.events) {
                if (this.oneLog.text.includes(event)) {
                    return event;
                }
            }
        },
        extractEventText(text, event) {
            switch (event) {
                case 'authorization.accepted':
                    return 'a autorisé la connexion à son compte.';
                case 'authorization.send':
                    return "a reçu une demande d'accès par email.";
                default:
                    return '';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.cd-timeline-card--default::v-deep {
    .container-authorization {
        display: flex;
        align-items: center;

        .text {
            margin: 0 var(--spacing-0) 0 0;
        }
    }
    .user {
        &-profile {
            margin: 0 var(--spacing-0) 0 0;
        }
    }
    .date-log {
        white-space: nowrap;
        color: var(--colors-common-text-standard-caption);
    }
}
</style>
